<i18n src="./SubscriptionInfo.txt" lang="yaml"></i18n>
<script src="./SubscriptionInfo.js"></script>

<template>
<div class="subscription-box" v-if="currentPath">
    <div class="subscription-check">
       <input class="subscription-input" type="checkbox" name="subscriptionCheckbox" @change="setDetailsFlag" />
       <span><label class="subscription-label" for="subscriptionCheckbox">Subscribe</label></span>
    </div>
    <div class="details-box" v-if="detailsFlag">
        <div class="subscription-details">
            <label class="frequency-label">Frequency</label>
            <select class="frequency-dropdown" v-model="selectedPackage" @change="setDetails()">
                <option v-for="subscription in subscriptionPackages" :key="subscription.value"
                    :value="subscription.value">
                    {{subscription.name}}
                </option>
            </select>
        </div>
        <div class="subscription-details">
            <!-- <datepicker placeholder="Order date" format="dd-MM-yyyy" v-on:selected="onDateChangeHandler"></datepicker> -->
            <label class="frequency-label">Subscription Date</label>
            <select class="frequency-dropdown" v-model="selectedDay" @change="onDateChangeHandler()">
                <option v-for="day in days" :key="day" :value="day">
                    {{day}}
                </option>
            </select>
        </div>
    </div>
</div>
</template>

<style>
.subscription-calendar {
  display: flex;
  margin-top: 5px;
}

.subscription-input {
  margin: 0px !important;
  width:17px;
}

.subscription-label {
  margin-bottom: 0px;
}

.frequency-label {
  width: 43%;
}

.frequency-dropdown {
  width: 30%;
  border: 1px solid #d6d6d6;
}

.details-box {
  border: 1px solid #d6d6d6;
  background-color: white;
  padding: 10px;
}

.subscription-box {
  display: flex;
  flex-direction: column;
  margin: 10px 0px;
}
.subscription-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  justify-content: flex-start;
}
.subscription-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
}



</style>